import { render } from "./ClockTimeFourOutline.vue?vue&type=template&id=56b4e4e6"
import script from "./ClockTimeFourOutline.vue?vue&type=script&lang=js"
export * from "./ClockTimeFourOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__